import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useSite } from "../context/SiteContext";

export function Footer() {
    const { data } = useSite();
    const settings = data?.settings || {};
    const socials = settings.socials || {};
    const year = new Date().getFullYear();

    return (
        <footer className="bg-forest-deep text-ivory/80 border-t border-gold/20" data-testid="main-footer">
            <div className="container-bc py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-2 space-y-4">
                    <Logo dark />
                    <p className="text-sm leading-relaxed max-w-sm">
                        {settings.tagline || "Transformation physique, nutrition et suivi corporel personnalisés."}
                    </p>
                    {settings.contact_email && (
                        <p className="text-sm">
                            Contact :{" "}
                            <a href={`mailto:${settings.contact_email}`} className="text-gold-light hover:underline" data-testid="footer-contact-email">
                                {settings.contact_email}
                            </a>
                        </p>
                    )}
                    {Object.keys(socials).length > 0 && (
                        <div className="flex gap-4 pt-1">
                            {Object.entries(socials).map(([net, url]) => (
                                <a key={net} href={url} target="_blank" rel="noopener noreferrer" className="text-gold-light hover:text-gold capitalize text-sm" data-testid={`footer-social-${net}`}>
                                    {net}
                                </a>
                            ))}
                        </div>
                    )}
                </div>
                <div>
                    <h3 className="font-heading font-bold text-ivory text-sm uppercase tracking-widest mb-4">Le site</h3>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/fonctionnement" className="hover:text-gold-light transition-colors" data-testid="footer-link-fonctionnement">Comment ça marche</Link></li>
                        <li><Link to="/fonctionnalites" className="hover:text-gold-light transition-colors" data-testid="footer-link-fonctionnalites">Fonctionnalités</Link></li>
                        <li><Link to="/boutique" className="hover:text-gold-light transition-colors" data-testid="footer-link-boutique">Boutique</Link></li>
                        <li><Link to="/#tarifs" className="hover:text-gold-light transition-colors" data-testid="footer-link-tarifs">Tarifs</Link></li>
                        <li><Link to="/#contact" className="hover:text-gold-light transition-colors" data-testid="footer-link-contact">Contact</Link></li>
                    </ul>
                </div>
                <div>
                    <h3 className="font-heading font-bold text-ivory text-sm uppercase tracking-widest mb-4">Légal</h3>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/confidentialite" className="hover:text-gold-light transition-colors" data-testid="footer-link-confidentialite">Politique de confidentialité</Link></li>
                        <li><Link to="/mentions-legales" className="hover:text-gold-light transition-colors" data-testid="footer-link-mentions">Mentions légales</Link></li>
                        <li><Link to="/cookies" className="hover:text-gold-light transition-colors" data-testid="footer-link-cookies">Politique cookies</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-ivory/10">
                <div className="container-bc py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-ivory/60">
                    <p>© {year} BODYCOACHIA — Tous droits réservés.</p>
                    <p>Application distribuée exclusivement via Google Play et l'App Store. Les mesures de composition corporelle sont des estimations, sans valeur de diagnostic médical.</p>
                </div>
            </div>
        </footer>
    );
}
